/**
 * HeroSection.jsx
 * Above-the-fold hero section for the QuitPact homepage.
 *
 * AC 1.1.1 - requirements met:
 *   - Clear heading visible immediately on page load
 *   - One-sentence value proposition below the heading
 *   - No scrolling required to see headline or CTA
 *
 * AC 1.1.2 - requirements met:
 *   - Single prominent CTA: "Check My Relapse Risk"
 *   - Button positioned inside hero (above the fold)
 *   - Only ONE primary action rendered (no competing CTAs here)
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import CTAButton from '../common/CTAButton';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section" aria-labelledby="hero-heading">

      {/* -- Floating animated bubbles -- */}
      <div className="hero-section__bubble hero-section__bubble--1" aria-hidden="true" />
      <div className="hero-section__bubble hero-section__bubble--2" aria-hidden="true" />
      <div className="hero-section__bubble hero-section__bubble--3" aria-hidden="true" />

      {/* -- Tagline badge -- */}
      <div className="hero-section__badge" aria-hidden="true">
        QuitPact to create an Impact
      </div>

      {/* -- Primary heading -- */}
      <h1 id="hero-heading" className="hero-section__heading">
        Know Your Smoking{' '}
        <span className="hero-section__heading--highlight">Relapse Risk.</span>
      </h1>

      {/* -- Value proposition -- */}
      <p className="hero-section__value-prop">
        A free, real-time risk check for people trying to quit smoking.
      </p>

      {/* -- Single primary CTA -- */}
      <CTAButton
        label="Check My Relapse Risk"
        to="/check-in"
        ariaLabel="Start your relapse risk check-in"
      />

      {/* -- Quick stats -- */}
      <div className="hero-section__stats">
        <div className="hero-section__stat">Free to use</div>
        <div className="hero-section__stat">2 min check-in</div>
      </div>

    </section>
  );
};

export default HeroSection;